import { createHandlerChainRunner, Handler, HandlerProps, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getPrintPageUserPreference, PrintPageModel } from "@waytek/Services/PrintPageService";

type Parameter = { id: string } & HasOnSuccess<PrintPageModel>;

type Props = {
    apiResult: PrintPageModel;
};

type HandlerType = Handler<Parameter, Props>;

const dispatchIsLoading = (isLoading: boolean, props: HandlerProps<Parameter, Props>) => {
    props.dispatch({
        type: "Custom/PrintImagesState/Loading",
        isLoading,
    } as any);
};

export const SetLoadingTrue: HandlerType = props => {
    dispatchIsLoading(true, props);
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        const result = await getPrintPageUserPreference(props.parameter.id);

        if (result.successful) {
            props.apiResult = result.result;

            props.dispatch({
                type: "Custom/PrintImagesState/SetPrintImagesPreference",
                hideImagesOnPrint: result.result.hideImagesOnPrint,
            } as any);
        } else {
            throw new Error("Failed to load user print image preference");
        }
    } catch (error) {
        props.dispatch({
            type: "Custom/StatementState/FailedToLoad",
            message: "Failed to load user print image preference",
        } as any);
        return false;
    }
};

export const SetLoadingFalse: HandlerType = props => {
    dispatchIsLoading(false, props);
};

export const chain = [SetLoadingTrue, RequestDataFromApi, SetLoadingFalse];

const loadPrintImagesPreference = createHandlerChainRunner(chain, "LoadPrintImagesPreference");
export default loadPrintImagesPreference;
